"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _smileyData = _interopRequireDefault(require("./smileyData"));
var _SmileyDiv = _interopRequireDefault(require("./SmileyDiv"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var SmileyContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-evenly;\n"])));
var Prompt = /*#__PURE__*/function (_React$Component) {
  function Prompt(props) {
    var _this;
    _classCallCheck(this, Prompt);
    _this = _callSuper(this, Prompt, [props]);
    _this.state = {
      selectedSmileyScore: 0
    };
    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }
  _inherits(Prompt, _React$Component);
  return _createClass(Prompt, [{
    key: "onClick",
    value: function onClick(selectedSmileyScore) {
      this.setState({
        selectedSmileyScore: selectedSmileyScore
      });
      this.props.onSelect(selectedSmileyScore);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          paddingBottom: "1rem"
        }
      }, "How satisfied are you?"), /*#__PURE__*/_react["default"].createElement(SmileyContainer, null, _smileyData["default"].map(function (smiley, idx) {
        return /*#__PURE__*/_react["default"].createElement(_SmileyDiv["default"], {
          key: idx,
          onClick: function onClick() {
            return _this2.onClick(smiley.score);
          },
          emoji: smiley.emoji,
          label: smiley.label,
          selected: smiley.score === _this2.state.selectedSmileyScore
        });
      })), /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          paddingTop: "1rem"
        }
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: this.props.feedbackFormLink,
        target: "_blank"
      }, "Click here if you need support.")));
    }
  }]);
}(_react["default"].Component);
Prompt.propTypes = {
  onSelect: _propTypes["default"].func.isRequired,
  feedbackFormLink: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = Prompt;